import styled from 'styled-components';
import Colors from '@/constants/Colors';

export const StyledActivityListItem = styled.div`
  border-bottom: 1px solid ${Colors.border};
  &:last-child {
    border-bottom: none;
  }

  .ant-list-item-meta {
    margin: 0px;
    align-items: center;
  }
  .activity-list-item {
    align-items: center;

    .ant-list-item-meta-title {
      margin: 0px;
    }
    .activity-title {
      text-transform: capitalize;

      .ant-tag {
        margin-left: 10px;
      }
    }
  }
  .activity-link:hover .activity-list-item {
    background-color: ${Colors.hoverBackground};
  }
`;
